import React from 'react';
import DownloadIcon from '../assets/icons/Download.svg';
import AirtableIcon from '../assets/icons/airtable-svgrepo-com.svg';
import { useSelector } from 'react-redux';
import Prescription from '../assets/icons/Prescription.svg'
import { Link } from 'react-router-dom';

export default function BloodTestHeader({
  header,
  orderId,
  reportUrl,
  airtablePreviewUrl,
  recordId,
  bloodTestId,
  prescriptionPrefill,
  onToggle,
  expanded,
}) {
  const displayOrderId = String(orderId || '').replace(/^N:/, '');
  const userRole = useSelector((state) => state?.user?.role || '');
  const isSupervisor = userRole === 'Supervisor';

  const buildAirtableRedirectUrl = React.useCallback((baseUrl, recId) => {
    const raw = String(baseUrl || '')
      .trim()
      .replace(/^['"]+|['"]+$/g, '');
    if (!raw) return '';

    const normalizedRecordId = String(recId || '').trim();

    // Ensure absolute URL (APIs sometimes return without https://).
    const absolute = /^https?:\/\//i.test(raw)
      ? raw
      : `https://${raw.replace(/^\/+/, '')}`;

    // Preserve hash/query, but make path deterministic.
    const [beforeHash, hash = ''] = absolute.split('#');
    const [pathPart, queryPart = ''] = beforeHash.split('?');

    // Remove existing record segment at the end if present, then append exactly one.
    const pathWithoutRecord = pathPart.replace(/\/rec[a-zA-Z0-9]+$/i, '');
    const finalPath = normalizedRecordId
      ? `${pathWithoutRecord}/${normalizedRecordId}`
      : pathWithoutRecord;

    const params = new URLSearchParams(queryPart);
    // Avoid duplicated recordId in the querystring.
    params.delete('recordId');
    const queryString = params.toString();

    const withQuery = queryString ? `${finalPath}?${queryString}` : finalPath;
    return hash ? `${withQuery}#${hash}` : withQuery;
  }, []);
  const finalAirtableUrl = buildAirtableRedirectUrl(
    airtablePreviewUrl || process.env.REACT_APP_AIRTABLE_PREVIEW_URL,
    recordId
  );
  return (
    <div className="flex items-start md:items-center justify-between gap-3 md:gap-4">
      <div className="text-xs md:text-sm font-poppins flex-1 md:w-auto">
        <div className="md:hidden space-y-2 pr-3">
          <div className="flex items-baseline gap-1">
            <span className="text-[#889696]">Type:</span>
            <span className="text-[#1E2426]">{header.type}</span>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-[#889696]">Test date:</span>
            <span className="text-[#1E2426]">
              {(header.testDate || '').replaceAll('/', '.')}
            </span>
          </div>
          <div className="flex items-baseline gap-1">
            <span className="text-[#889696]">Result date:</span>
            <span className="text-[#1E2426]">
              {(header.resultDate || '').replaceAll('/', '.')}
            </span>
          </div>
        </div>
        <div className="hidden md:flex gap-8">
          {expanded ? (
            <>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Type:</span>
                <span className="text-[#1E2426] font-normal">
                  {header.type}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Test date:</span>
                <span className="text-[#1E2426] font-normal">
                  {(header.testDate || '').replaceAll('/', '.')}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Result date:</span>
                <span className="text-[#1E2426] font-normal">
                  {(header.resultDate || '').replaceAll('/', '.')}
                </span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Order ID:</span>
                <span className="text-[#1E2426] font-normal">
                  № {displayOrderId}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Type:</span>
                <span className="text-[#1E2426] font-normal">
                  {header.type}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#889696] font-normal">Test date:</span>
                <span className="text-[#1E2426] font-normal">
                  {(header.testDate || '').replaceAll('/', '.')}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
        {isSupervisor ? (
          <Link
            to="/blood-test-prescription"
            state={{
              summaryPrefill: prescriptionPrefill || null,
              recordId: String(recordId || '').trim(),
              bloodTestId: String(bloodTestId || '').trim(),
              bloodTestSummary: {
                orderId: String(orderId || '').trim(),
                testType: String(header?.type || '').trim(),
                testDate: String(header?.testDate || '').trim(),
                resultDate: String(header?.resultDate || '').trim(),
              },
            }}
            className="group flex items-center gap-2 h-9 md:h-10 px-3 md:px-4 border border-gray-300 rounded-lg transition-colors hover:bg-gray-50"
          >
             <img src={Prescription} alt="" className="w-4 h-4" />
            {/* <span className="text-sm md:text-base font-poppins font-medium text-[#2B3133] group-hover:text-[#119975]">
              Pers
            </span> */}
          </Link>
        ) : null}
        
        {isSupervisor ? (
          <a
            href={finalAirtableUrl || undefined}
            target="_blank"
            rel="noopener noreferrer"
            aria-disabled={!finalAirtableUrl}
            onClick={(e) => {
              if (!finalAirtableUrl) e.preventDefault();
            }}
            className={`group flex items-center gap-2 h-9 md:h-10 px-3 md:px-4 border border-gray-300 rounded-lg transition-colors ${finalAirtableUrl ? 'hover:bg-gray-50' : 'opacity-50 cursor-not-allowed'
              }`}
          >
            <img src={AirtableIcon} alt="" className="w-4 h-4" />
            {/* <span className="text-sm md:text-base font-poppins font-medium text-[#2B3133] group-hover:text-[#119975]">
              Airtable
            </span> */}
          </a>
        ) : null}
        <button
          type="button"
          aria-disabled={!reportUrl}
          onClick={async () => {
            if (!reportUrl) return;
            try {
              const res = await fetch(reportUrl);
              const blob = await res.blob();
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              const suggested = `${header?.type || 'report'}_${(
                header?.resultDate || ''
              )
                .toString()
                .replaceAll('/', '-')}.pdf`;
              a.download = suggested;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              // noop
            }
          }}
          className={`h-9 md:h-10 px-3 md:px-4 border border-gray-300 rounded-lg flex items-center justify-center transition-colors ${reportUrl ? 'hover:bg-gray-50' : 'opacity-50 cursor-not-allowed'
            }`}
        >
          <img src={DownloadIcon} alt="download" className="w-4 h-4" />
        </button>
        <button
          onClick={onToggle}
          aria-pressed={!!expanded}
          className="group flex items-center gap-2 h-9 md:h-10 px-3 md:px-4 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <span
            className={`text-sm md:text-base font-poppins font-medium text-[#2B3133] group-hover:text-[#119975]`}
          >
            View
          </span>
          <svg
            className={`text-gray-600 group-hover:text-[#119975] w-4 h-4 transform transition-transform ${expanded ? 'rotate-180' : ''}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
